import { castArray, isFunction } from 'lodash';
import { ERROR_MESSAGES } from './validationRules';

export const getErrorMessage = (errorCode, args) => {
  if (ERROR_MESSAGES[errorCode]) {
    const fn = isFunction(ERROR_MESSAGES[errorCode])
      ? ERROR_MESSAGES[errorCode]
      : () => ERROR_MESSAGES[errorCode];

    return fn(args);
  }

  return errorCode;
};

export const getErrorCode = (value, errorCode) => (value ? errorCode : undefined);

export const validate = ({ validations, raw = false, messages = false }) => (values, form) => {
  let errors = {};

  Object.entries(validations).forEach(([name, value]) => {
    let fieldErrors = [];
    castArray(value).forEach(validation => {
      const [errorCode, args] = validation(values[name], values, form);

      if (errorCode) {
        fieldErrors.push(messages ? getErrorMessage(errorCode, args) : errorCode);
      }
    });

    if (fieldErrors.length) errors[name] = raw ? fieldErrors : fieldErrors.join(', ');
  });

  return errors;
};

export const bytesToMegaBytes = bytes => bytes / (1024 * 1024);
